import { render, staticRenderFns } from "./OFCORE.vue?vue&type=template&id=76d7f34e&"
import script from "./OFCORE.vue?vue&type=script&lang=js&"
export * from "./OFCORE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d7f34e')) {
      api.createRecord('76d7f34e', component.options)
    } else {
      api.reload('76d7f34e', component.options)
    }
    module.hot.accept("./OFCORE.vue?vue&type=template&id=76d7f34e&", function () {
      api.rerender('76d7f34e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/OFCORE.vue"
export default component.exports